import { ReactElement } from 'react';
import { BombiixSidePanel } from '../BombiixSidePanel';
import { BombiixReorderList, BombiixReorderItem } from '../BombiixReorderList';

export interface BombiixRearrangePanelProps {
  isOpen: boolean;
  title: string;
  items: BombiixReorderItem[];
  onReorder: (_items: BombiixReorderItem[]) => void;
  onSave: () => void;
  onClose: () => void;
  saveLabel?: string | undefined;
  saveLoading?: boolean | undefined;
  moveHint?: string | undefined;
  testId?: string | undefined;
  /** Element the panel hangs beneath. Pass `null` to pin it to the viewport top. */
  anchorSelector?: string | null | undefined;
}

/**
 * Bombiix master-design Rearrange Sequence panel (Figma node 13564:537594).
 * Owns the whole view — side-panel chrome, body padding and the reorder list —
 * so callers pass data and handlers only. Spacing is fixed by
 * `assets/scss/master-design/_rearrange-panel.scss`; there is deliberately no
 * `className` escape hatch, which is what keeps every Rearrange view identical.
 * @param {BombiixRearrangePanelProps} props - Open state, rows and handlers.
 * @returns {ReactElement} The Rearrange panel.
 */
export function BombiixRearrangePanel({
  isOpen,
  title,
  items,
  onReorder,
  onSave,
  onClose,
  saveLabel,
  saveLoading,
  moveHint,
  testId,
  anchorSelector,
}: BombiixRearrangePanelProps): ReactElement {
  return (
    <BombiixSidePanel
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      onSave={onSave}
      saveLabel={saveLabel ?? 'Save'}
      saveLoading={saveLoading ?? false}
      anchorSelector={anchorSelector === undefined ? '.page-title-filter' : anchorSelector}
      className="bombiix-rearrange-panel"
    >
      <BombiixReorderList items={items} onReorder={onReorder} ariaLabel={title} moveHint={moveHint} testId={testId} />
    </BombiixSidePanel>
  );
}

export default BombiixRearrangePanel;
